import React from 'react';
import './SectionHeader.css';

/**
 * Reusable Section Header Component
 * @param {React.ElementType} icon - The Lucide icon component (e.g., BookOpen, Award, Layers)
 * @param {string} title - Heading text
 * @param {string} [className] - Optional container CSS class override
 */
const SectionHeader = ({ icon: Icon, title, className = '' }) => {
  return (
    <div className={`section-header ${className}`}>
      {Icon && <Icon className="section-header-icon" size={16} />}
      <h2 className="section-header-title">{title}</h2>
    </div>
  );
};

export default SectionHeader;